import {ServerApi} from "../api.js";
import {handleFetchError, showNotice} from "../helpers/functions.js";
import JSX from "../helpers/react.js";
import RefObject = JSX.RefObject;
import {IOneVideoJson} from "../../../../nodeserver/structs/database";
import {DataStore} from "../helpers/datastore.js";

declare global {
    export interface EventsTypes {
        onVideoWatch: (video: IOneVideoJson, time: number, duration: number) => void;
        onEnterPip: (video: IOneVideoJson) => void;
        onExitPip: (video: IOneVideoJson) => void;
        onDurationUpdated: (video: IOneVideoJson, duration: number) => void;
        onVideoChange: (video: IOneVideoJson) => void;
        onSubscribeButtonClick: (video: IOneVideoJson, subscribed: boolean) => Promise<unknown>;
        onEnterFullScreen: () => void;
        onExitFullScreen: () => void;
        /*return true if need skip to the next video.*/
        onVideoEnd: (video: IOneVideoJson) => boolean;

    }

    interface VideoElementANS {
        updateWatched: (watchedVideos: { video_id: number, time: number }[]) => unknown;
        updateOldDesign: (oldDesign: boolean) => unknown;
    }

    function VideoElement(element: HTMLElement, data: IOneVideoJson[], events: EventsTypes, watchesDefault: ({
        video_id: number,
        time: number
    })[], oldDesign: boolean): VideoElementANS;
}
if (page_type == 'anime') $(() => {
    const videoContent = document.getElementById('video')!;
    if (!videoContent!.children[0]?.classList?.contains('loading')) return;
    if ('VideoElement' in window) {
        doWork(videoContent)
    } else {
        (window as any).reactLoadedEvent = () => doWork(videoContent);
    }

});

let lastWatch: { video_id: number, time: number } | null = null;
window.addEventListener('beforeunload', () => {
    if (lastWatch) {
        ServerApi.video.watchVideo(lastWatch.video_id, Math.round(lastWatch.time));
    }
});

async function doWork(parent: HTMLElement) {
    try {
        const [data, watchedLocal] = await Promise.all(
            [
                ServerApi.anime.getVideos(page_id!),
                DataStore.getAnimeById(page_id!)
                    .then(e => e?.epWatched)
                    .catch(e => {
                        console.error(e);
                        return null
                    })
            ]
        );
        if (!data.length) {
            parent.innerHTML = '<div class="error-notification status-bg alert-bg bordered">Видео не найдено</div>';
            (document.querySelector('.trailers-tab') as HTMLElement)?.click()
            return;
        }

        const events: EventsTypes = {
            onDurationUpdated: (video, duration) => {

            },
            onEnterPip() {
            },
            onExitPip() {
            },
            async onSubscribeButtonClick(video, subscribe) {
                if (!user_id) {
                    showNotice('Для подписки необходимо авторизоваться', 'Ошибка', 'error');
                    throw new Error('Вы не авторизованы');
                }
                try {
                    if (!subscribe) {
                        await ServerApi.video.unsubscribeFrom(video.video_id);
                        showNotice('Вы отписались от уведомлений о новых сериях', 'Отписка', 'normal')
                    } else {
                        await ServerApi.video.subscribeTo(video.video_id);
                        showNotice('Вы подписались на уведомления о новых сериях', 'Успех', 'success')
                    }
                } catch (e) {
                    handleFetchError(e);
                    throw e;
                }
            },
            async onVideoChange(video) {
                if (!lastWatch) return;
                try {
                    const {time, video_id} = lastWatch;
                    lastWatch = null;
                    await ServerApi.video.watchVideo(video_id, Math.round(time));
                } catch (e) {
                    console.error(e);
                }
            },
            onVideoWatch(video, time, duration) {
                time = Math.max(Math.min(time, duration - 10), 0);
                let el = watched.find(e => e.video_id == video.video_id);
                if (!el) {
                    watched.push(el = {video_id: video.video_id, time, date: Math.floor(+new Date() / 1000)});
                }
                el.time = time;
                DataStore.getAnimeById(page_id!).then(anime => {
                    anime?.setEpWatched(video.video_id, {
                        time,
                        date: Math.floor(+new Date() / 1000)
                    });
                    return anime?.update();
                })
                    .catch(console.error);
                updateWatched(watched);
                lastWatch = {video_id: video.video_id, time};
                // TODO: send every 30 seconds data to the server
            },
            onExitFullScreen() {

            },
            onEnterFullScreen() {

            },
            onVideoEnd() {
                return localStorage.autoSkipNextEp !== "false";
            }
        }

        let watched = data.filter(e => e.watched)
            .map(e => ({video_id: e.video_id, time: e.watched!.end_time, date: e.watched!.date}));
        // console.log(`Watched: ${JSON.stringify(watched)}`);
        for (const [video_id, data] of watchedLocal ?? []) {
            const el = watched.find(e => e.video_id == video_id);
            if (el) el.time = Math.max(data.time, el.time);
            else watched.push({video_id, time: data.time, date: data.date});
        }
        watched.sort((a, b) => a.date - b.date);
        const {
            updateWatched,
            updateOldDesign
        } = VideoElement(parent, data, events, watched, !(localStorage.designSwitch !== 'false'));
        (window as any)._onchangeOldDesign = (v: any) => updateOldDesign(v);
    } catch (e) {
        handleFetchError(e);
        parent.innerText = '';
        parent.appendChild(<RetryButton retry={() => doWork(parent)}/>)
    }
}


function RetryButton({retry}: { retry: () => any }) {
    const btn: RefObject<HTMLButtonElement> = {};
    return (
        <div className="center retry-loading-button" ref={btn}>
            <p>Не удалось загрузить видео</p>
            <button className="main-button bordered" onClick={() => {
                btn.value!.remove();
                retry()
            }}>Загрузить ещё раз
            </button>
        </div>
    )
}
